// eslint-disable-next-line import/order
import type { Command } from '@atlaskit/editor-common/types/command';
import { Selection } from '@atlaskit/editor-prosemirror/state';
import type { Transaction, EditorState } from '@atlaskit/editor-prosemirror/state';
import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import { createCommand, getPluginState } from '../plugin-factory';
import { ACTIONS } from '../states';
// eslint-disable-next-line import/order
import type { InlineSuggestion } from '../states';

export function insertInlineSuggestion(): Command {
	return createCommand(
		() => ({ type: ACTIONS.CLEAR_INLINE_SUGGESTION }),
		(tr: Transaction, state: EditorState) => {
			const { inlineSuggestion } = getPluginState(state);
			if (!inlineSuggestion) {
				return tr;
			}
			tr.replaceWith(inlineSuggestion.from, inlineSuggestion.to, inlineSuggestion.suggestedNode);
			tr.setSelection(
				Selection.near(
					tr.doc.resolve(inlineSuggestion.from + inlineSuggestion.suggestedNode.nodeSize),
				),
			);
			return tr;
		},
	);
}

export function clearSuggestion(): Command {
	return createCommand(() => ({ type: ACTIONS.CLEAR_INLINE_SUGGESTION }));
}

export function updateInlineSuggestion(
	inlineSuggestion: InlineSuggestion | null,
	decorationSet: DecorationSet,
): Command {
	return createCommand(() => ({
		type: ACTIONS.UPDATE_INLINE_SUGGESTION,
		payload: {
			inlineSuggestion,
			decorationSet,
		},
	}));
}

export function updateLocale(locale: string): Command {
	return createCommand(() => ({
		type: ACTIONS.UPDATE_LOCALE,
		payload: {
			locale,
		},
	}));
}
